import { render, staticRenderFns } from "./SpacePlanTile.vue?vue&type=template&id=4857ab66&scoped=true&"
import script from "./SpacePlanTile.vue?vue&type=script&lang=js&"
export * from "./SpacePlanTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857ab66",
  null
  
)

export default component.exports